import React, { Component } from 'react';
import { Image, Button } from 'react-bootstrap';
import AuthService from '../services/auth.service';
import '../content/css/NotAllowedPage.css';

var logo = require("../content/images/legly_logo_color.svg");

export default class NotAllowedPage extends Component {
    constructor(props) {
        super(props);

        this.auth0 = new AuthService();
        this.handleUpdateClick = this.handleUpdateClick.bind(this);
    }

    handleUpdateClick() {
        this.auth0.login();
    }

    render() {
        return (
            <div className="center-horizontally">
                <div>
                    <Image className="logo" src={logo} />
                    <h1>Welcome to Legly Contract Review!</h1>
                    <p>Your account is currently being verified. Please refresh in a few moments.</p>
                    <Button variant="secondary" onClick={this.handleUpdateClick}>Refresh</Button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/NotAllowedPage.js